import axios from './axios'

export default class TrainingService{
    static async list(query){
        return await axios.get("/tranning-center/list",{params:query})
    }

    static async detail(slug){
        return await axios.get("/tranning-center/details/"+slug)
    }
}